export function initEventAccordion() {
  document.querySelectorAll('.flip-event-accordion__trigger').forEach((btn) => {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;

    panel.style.height = '0px';
    panel.style.overflow = 'hidden';
    panel.hidden = false;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.height = '0px';
        });
      } else {
        panel.style.height = panel.scrollHeight + 'px';
        const onEnd = () => {
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', onEnd);
        };
        if (prefersReduced) {
          panel.style.height = 'auto';
        } else {
          panel.addEventListener('transitionend', onEnd);
        }
      }

      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  document.querySelectorAll('.flip-event-cal-dropdown__toggle').forEach((btn) => {
    const menu = btn.nextElementSibling;
    if (!menu) return;

    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });

    document.addEventListener('click', (e) => {
      if (!btn.closest('.flip-event-cal-dropdown').contains(e.target)) {
        btn.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        btn.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        btn.focus();
      }
    });
  });

  document.querySelectorAll('.flip-event-share__copy').forEach((btn) => {
    btn.addEventListener('click', () => {
      const url = btn.dataset.url;
      if (!url) return;

      const showCopied = () => {
        const label = btn.getAttribute('aria-label');
        btn.setAttribute('aria-label', 'Copied!');
        btn.classList.add('is-copied');
        setTimeout(() => {
          btn.setAttribute('aria-label', label);
          btn.classList.remove('is-copied');
        }, 2000);
      };

      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(showCopied).catch(() => {
          fallbackCopy(url) && showCopied();
        });
      } else {
        fallbackCopy(url) && showCopied();
      }
    });
  });

  function fallbackCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { /* ignore */ }
    document.body.removeChild(ta);
    return ok;
  }
}
